import { ItemPayment } from 'actions/actionTypes';

// 아이템 결제 팝업 노출 여부
export const changePaymentGatewayRequestOpen = () => ({ type: ItemPayment.CHANGE_PAYMENT_GATEWAY_REQUEST_OPEN });

// 아이템 결제 방식(신용카드,계좌이체)에 따른 script 요청
export const addItemPaymentMethodRequest = (type, totalPrice, itemId, quantity) => ({ type: ItemPayment.ADD_ITEM_PAYMENT_METHOD_REQUEST, payload: {type, totalPrice, itemId, quantity} });
export const addItemPaymentMethodSuccess = (responseData) => ({ type: ItemPayment.ADD_ITEM_PAYMENT_METHOD_SUCCESS, payload: responseData });
export const addItemPaymentMethodFailure = (errorMessage) => ({ type: ItemPayment.ADD_ITEM_PAYMENT_METHOD_FAILURE, payload: errorMessage });

// 아이템 결제 script
export const contentsItemPaymentSuccess = () => ({ type: ItemPayment.ITEM_PAYMENT_SUCCESS});

// 이벤트
export const changeItemPaymentHistorySearchFilter = (type, name, value) => ({
    type: ItemPayment.CHANGE_ITEM_PAYMENT_HISTORY_SEARCH_FILTER,
    payload: { type, name, value },
});

//  아이템 구매 내역 조회
export const loadItemPaymentHistoryListRequest = () => ({
    type: ItemPayment.LOAD_ITEM_PAYMENT_HISTORY_LIST_REQUEST,
});
export const loadItemPaymentHistoryListSuccess = (responseData) => ({
    type: ItemPayment.LOAD_ITEM_PAYMENT_HISTORY_LIST_SUCCESS,
    payload: responseData,
});
export const loadItemPaymentHistoryListFailure = (errorMessage) => ({
    type: ItemPayment.LOAD_ITEM_PAYMENT_HISTORY_LIST_FAILURE,
    payload: errorMessage,
});